module.exports = __webpack_public_path__ + "static/media/service-main-2.4fae07fc.svg";